// Copyright 2025, University of Maryland, All Rights Reserved
import { memo } from 'react'
import { GitCompare } from 'lucide-react'

import { BaseNode } from '@/subsystems/pipelines'

export const DecisionGateWorkflowNode = memo(() => (
  <BaseNode
    icon={<GitCompare />}
    label="Decision Gate"
    hasInput
    hasOutput
  />
))

DecisionGateWorkflowNode.displayName = 'DecisionGateWorkflowNode'
